// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"088c3a37","977":"dbd6bfb7"}[chunkId] + ".chunk.js";
};